// scheduling/services/suggestions.js
// Suggestion triage + "my suggestions" service. Sibling of bugReports.js.
//
// Reads + resolves go through the RPRS proxies (api/suggestions,
// api/suggestions-resolve) → func-shared-services, the sole writer to
// Feedback.*. ContextApp is server-derived from the app key, and scope=all /
// resolve are gated on ADMIN_EMAILS upstream. The submitter notification on a
// status change is an rprs schedWrite (notify_suggestion_updated) — re-exported
// here so the triage UI imports everything suggestion-related from one module.

import { fetchWithColdStartRetry, notifySuggestionUpdated } from './schedApi';

async function postJson(url, body, label) {
  const r = await fetchWithColdStartRetry(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  }, { label });
  if (!r.ok) {
    const err = await r.text();
    throw new Error(`${label} ${r.status}: ${err}`);
  }
  return r.json();
}

// List or single detail. filters: { scope:'mine'|'all', status?, id? }
//   → { ok, suggestions:[…] }  or  { ok, suggestion:{…} }
export const fetchSuggestions = (filters = {}) =>
  postJson('/api/suggestions', filters, 'suggestions');

// Advance one or many. payload: { ids, status, resolutionNote?, addressedInRef? }
//   → { ok, resolved:[{ suggestionId, submittedBy, title, status, resolutionNote }] }
export const resolveSuggestions = (payload) =>
  postJson('/api/suggestions-resolve', payload, 'suggestions-resolve');

export { notifySuggestionUpdated };
